import { render, staticRenderFns } from "./CaboLogo.vue?vue&type=template&id=60934592&scoped=true"
import script from "./CaboLogo.vue?vue&type=script&lang=js"
export * from "./CaboLogo.vue?vue&type=script&lang=js"
import style0 from "./CaboLogo.vue?vue&type=style&index=0&id=60934592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60934592",
  null
  
)

export default component.exports